import { Component, OnInit } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';

@ManageType('DrugDialogComponent')
@Component({
  selector: 'app-drug-dialog',
  templateUrl: './drug-dialog.component.html',
  styleUrls: ['./drug-dialog.component.scss']
})
export class DrugDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
